import { PhoenixBookHotelHeaderData, PhoenixBookHotelHeaderDataAuth } from '../Queries';

export const mockResponse = {
  data: {
    order: {
      __typename: 'Order',
      items: [
        {
          __typename: 'OrderLineItem',
          property: {
            __typename: 'Hotel',
            basicInformation: {
              __typename: 'HotelBasicInformation',
              name: 'New York Marriott Marquis',
              brand: {
                __typename: 'Brand',
                id: 'MC',
              },
            },
            contactInformation: {
              __typename: 'PropertyContactInformation',
              address: {
                __typename: 'PropertyAddress',
                line1: '1535 Broadway',
                line2: null,
                line3: null,
                city: 'New York',
                country: {
                  __typename: 'Lookup',
                  description: 'USA',
                },
                stateProvince: {
                  __typename: 'Lookup',
                  description: 'New York',
                },
                postalCode: '10036',
              },
              contactNumbers: [
                {
                  __typename: 'ContactNumber',
                  number: '+18008434898',
                },
                {
                  __typename: 'ContactNumber',
                  number: '+12123981900',
                },
                {
                  __typename: 'ContactNumber',
                  number: '+12123981900',
                },
                {
                  __typename: 'ContactNumber',
                  number: '+12127048930',
                },
                {
                  __typename: 'ContactNumber',
                  number: '+12127048969',
                },
                {
                  __typename: 'ContactNumber',
                  number: null,
                },
              ],
            },
            seoNickname: 'nycmq-new-york-marriott-marquis',
          },
        },
      ],
    },
  },
};

export const hotelHeaderMocks = {
  request: {
    query: PhoenixBookHotelHeaderDataAuth,
    variables: {
      propertyId: 'nycmq',
      customerId: 'C81F095343EDFB2228F8F742062909463.01',
    },
  },
  result: {
    data: {
      property: {
        basicInformation: {
          latitude: 40.755589,
          longitude: -73.981863,
          name: 'The Algonquin Hotel Times Square, Autograph Collection',
          brand: {
            id: 'AK',
          },
        },
        reviews: {
          numberOfReviews: {
            count: 1343,
            description: 'Based on 1343 guest reviews',
          },
          stars: {
            count: 4.3,
            description: '4.3 out of 5.0',
          },
        },
        contactInformation: {
          contactNumbers: [
            {
              number: '+12128406800',
              type: {
                description: 'Phone',
                code: 'phone',
              },
            },
            {
              number: '+12129441419',
              type: {
                description: 'Fax',
                code: 'fax',
              },
            },
          ],
          address: {
            line1: '59 West 44th Street',
            line2: null,
            line3: null,
            city: 'New York',
            stateProvince: {
              description: 'New York',
            },
            country: {
              description: 'USA',
            },
            postalCode: '10036',
          },
        },
        seoNickname: 'nycak-the-algonquin-hotel-times-square-autograph-collection',
      },
    },
  },
};

export const apiResponse = {
  data: {
    property: {
      basicInformation: {
        latitude: 40.755589,
        longitude: -73.981863,
        name: 'The Algonquin Hotel Times Square, Autograph Collection',
        brand: {
          id: 'AK',
        },
      },
      reviews: {
        numberOfReviews: {
          count: 1343,
          description: 'Based on 1343 guest reviews',
        },
        stars: {
          count: 4.3,
          description: '4.3 out of 5.0',
        },
      },
      contactInformation: {
        contactNumbers: [
          {
            number: '+12128406800',
            type: {
              description: 'Phone',
              code: 'phone',
            },
          },
          {
            number: '+12129441419',
            type: {
              description: 'Fax',
              code: 'fax',
            },
          },
        ],
        address: {
          line1: '59 West 44th Street',
          line2: null,
          line3: null,
          city: 'New York',
          stateProvince: {
            description: 'New York',
          },
          country: {
            description: 'USA',
          },
          postalCode: '10036',
        },
      },
      seoNickname: 'nycak-the-algonquin-hotel-times-square-autograph-collection',
    },
  },
};
export const hotelHeaderMockRRD = {
  request: {
    query: PhoenixBookHotelHeaderData,
    variables: {
      propertyId: 'ncymq',
    },
  },
  result: apiResponse,
};
const SESSION_VALUE = 'A4ECE2C5-A89A-5AF5-8FD9-AB140BD7C8C2';
export const sessionMock = {
  sessionToken: SESSION_VALUE,
  cacheData: {
    data: {
      billingCode: null,
      consumerID: 'C81F095343EDFB2228F8F742062909463.01',
      AriesReservation: {
        tripId: '97190792',
        upsellItemId: 'OTcxOTA3OTJfaXRlbQ==',
        travelInsurancePreferenceDetails: {
          quantity: null,
          insuranceCost: null,
          insuranceCurrency: null,
        },
        tripsXRequestedByHeader: 'cmFtOiw5NzE5MDc5MixKT0hOLFNBTVNPTiwyMDIyLTA5LTI3LDIwMjItMDktMTZUMDM6NDA6NTRa',
        propertyId: 'nycmq',
        locale: 'en_US',
        enrollmentStatus: null,
        RewardsNumber: null,
        enrollmentErrorMessage: null,
        rewardsNumber: null,
        numberOfRooms: 1,
        redemptionOptionsType: null,
        itemId: 'OTcxOTA3OTJfaXRlbQ==',
        isRewardsRedemptionFlow: false,
        cancelledReservation: false,
        numberInParty: null,
      },
      AriesCommon: {
        isProd: null,
        altCustId: null,
      },
    },
  },
  httpStatusCode: 200,
  status: 'SUCCESS',
  message: 'Session data fetched successfully',
  messageCode: 'SUCCESS-GA-005',
  authenticated: true,
  locale: 'en_US',
};

export const HotelHeaderMockProps = {
  componentId: '',
  seoNickname: 'nycak-the-algonquin-hotel-times-square-autograph-collection',
  hotelName: 'The Algonquin Hotel Times Square, Autograph Collection',
  fileReference: { damPath: '', assetPath: '', altText: '', dynamic: true, renditions: [] },
  latitude: '40.755589',
  longitude: '-73.981863',
  hotelAddress: '59 W 44th St, New York, NY 10036, USA',
  phone: '+(203) 245 5633',
  showReviews: true,
  suppressReviews: true,
  stars: {},
  hotelReviews: {},
  reviews: 'reviews',
  isLoading: false,
  viewDetailsLabel: 'View Details',
  pageType: 'rrd',
  savedLabel: 'saved',
  saveLabel: 'save',
  brandCode: 'mc',
  propertyId: 'nycmq',
  userData: { revisionToken: '', savedProperties: [{}] },
  showSaveProperty: false,
  handleClick: () => null,
  overridePropertyCountry: true,
  overridePropertyCountryText: 'Taiwan',
};

export const HotelHeaderRLMMockProps = {
  componentId: '',
  seoNickname: 'nycak-the-algonquin-hotel-times-square-autograph-collection',
  hotelName: 'The Algonquin Hotel Times Square, Autograph Collection',
  fileReference: { damPath: '', assetPath: '', altText: '', dynamic: true, renditions: [] },
  latitude: '40.755589',
  longitude: '-73.981863',
  hotelAddress: '59 W 44th St, New York, NY 10036, USA',
  phone: '+(203) 245 5633',
  showReviews: true,
  suppressReviews: false,
  stars: {},
  hotelReviews: {},
  reviews: 'reviews',
  isLoading: false,
  viewDetailsLabel: 'View Details',
  pageType: 'rlm',
  savedLabel: 'saved',
  saveLabel: 'save',
  brandCode: 'mc',
  propertyId: 'nycmq',
  userData: { revisionToken: '', savedProperties: [{ id: 'nycxr' }] },
  showSaveProperty: true,
  handleClick: () => null,
  overridePropertyCountry: true,
  overridePropertyCountryText: 'Taiwan',
};
